export default __webpack_public_path__ + "static/media/background.f3587494.png";